import { render, staticRenderFns } from "./product-select-new-modal.vue?vue&type=template&id=3dd8387c&scoped=true&"
import script from "./product-select-new-modal.vue?vue&type=script&lang=js&"
export * from "./product-select-new-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd8387c",
  null
  
)

export default component.exports